// extracted by mini-css-extract-plugin
module.exports = {"inlineInputButton":"add-user-page_inlineInputButton__1jAoA","addUserButtons":"add-user-page_addUserButtons__3U2tG"};